import React from "react"
import { twMerge } from "tailwind-merge"
import { ChevronUpIcon } from "@heroicons/react/20/solid"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import { ChevronRightIcon } from "@heroicons/react/20/solid"

const Table = props => {
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 xl:overflow-x-visible">
        <div
          className={twMerge([
            "inline-block min-w-full border-b border-slate-200 align-middle shadow sm:rounded-lg",
            props.sticky
              ? "overflow-hidden lg:overflow-visible"
              : "overflow-hidden",
          ])}
        >
          <table className={twMerge(["min-w-full", props.className])}>
            {props.children}
          </table>
        </div>
      </div>
    </div>
  )
}
const Th = props => {
  return (
    <th
      colSpan={props.colSpan}
      className={twMerge([
        "border-b border-blue-200 bg-slate-700 px-6 py-3 text-left text-xs font-medium uppercase leading-4 tracking-wider text-slate-50",
        props.className,
      ])}
    >
      {props.children}
    </th>
  )
}
const ThSort = props => {
  const chevStyle = "ml-1 inline h-4 w-4 stroke-current text-slate-50"
  let chevStatus = "right"
  if (props.sort.key === props.token) {
    if (props.sort.direction === "ascending") {
      chevStatus = "down"
    }
    if (props.sort.direction === "descending") {
      chevStatus = "up"
    }
  } else {
    chevStatus = "right"
  }
  return (
    <div className="flex flex-row items-center">
      <button
        className="text-xs font-medium uppercase leading-4 tracking-wider text-slate-50 hover:text-white hover:underline focus:outline-none"
        onClick={props.onClick}
      >
        {props.children}
      </button>

      <ChevronDownIcon
        className={twMerge([
          chevStyle,
          chevStatus === "down" ? "inline" : "hidden",
        ])}
      />
      <ChevronUpIcon
        className={twMerge([
          chevStyle,
          chevStatus === "up" ? "inline" : "hidden",
        ])}
      />
      <ChevronRightIcon
        className={twMerge([
          chevStyle,
          chevStatus === "right" ? "inline" : "hidden",
        ])}
      />
    </div>
  )
}
const Tr = props => {
  return (
    <tr
      id={props.id}
      className={twMerge(["bg-white even:bg-slate-50", props.className])}
      onClick={props.onClick}
    >
      {props.children}
    </tr>
  )
}
const Td = props => {
  return (
    <td
      rowSpan={props.rowspan}
      colSpan={props.colspan}
      className={twMerge([
        "whitespace-nowrap px-6 py-4 text-sm leading-5 text-slate-500",
        props.bold && "font-medium text-slate-900",
        props.className,
      ])}
    >
      {props.children}
    </td>
  )
}
const Thead = props => {
  return <thead className={twMerge([props.className])}>{props.children}</thead>
}
const Tbody = props => {
  return <tbody className={twMerge([props.className])}>{props.children}</tbody>
}

export { Table, Thead, Tbody, Th, ThSort, Tr, Td }
